import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
// From lib
import { Formik, Form } from 'formik';
// Components
import './ContactForm.css';
// Actions
import { addContactInfo } from '../../actions/actionCreators';
import { addRecaptchaToken } from '../../actions/actionCreators';
import { contactFormValidation } from '../../utils/validationRules';
// Intl
import {
    FormattedMessage,
    injectIntl
} from "react-intl";

class ContactForm extends React.Component {
    render() {
        let translations = this.props.intl.messages;
        let inquiryData = this.props.inquiryData.contact;

        return (
            <div className="contact-info">
                <Formik
                    initialValues={{
                        name: inquiryData.name || '',
                        email: inquiryData.email || '',
                        countryCode: inquiryData.countryCode || '',
                        phone: inquiryData.phone || '',
                        address: '',
                        zipCode: '',
                        city: '',
                        country: '',
                        birthDate: ''
                    }}
                    validationSchema={contactFormValidation}
                    onSubmit={(values) => {
                        grecaptcha.enterprise.ready(async () => {
                            grecaptcha.enterprise.execute('6LfPbN8nAAAAAPWdxbFFCK4fUCscG2q1nEXxTm1p', {action: 'submit_contact_info'})
                            .then(token => {
                                this.props.addRecaptchaToken(token);
                                values.countryCode = values.countryCode || '+47';
                                const payload = { ...values };
                                this.props.addContactInfo(payload);
                                this.props.router.navigate('/verify-phone-number');
                            });
                        });
                    }}>
                {({
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleBlur,
                    isValid,
                    isSubmitting
                }) => (
                    <Form>
                        <div className="field">
                            <label className="label" htmlFor="name">
                                <FormattedMessage id="formLabelName" defaultMessage="Name" />
                            </label>
                                <input
                                    id="name"
                                    placeholder={translations.formPlaceholderName}
                                    type="text"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={errors.name && touched.name ? 'input error' : 'input'}
                                />
                            {errors.name && touched.name && <div className="input-feedback">{errors.name}</div>}
                        </div>

                        <div className="field">
                            <label className="label" htmlFor="email">
                                <FormattedMessage id="formLabelEmail" defaultMessage="E-mail" />
                            </label>
                                <input
                                    id="email"
                                    placeholder={translations.formPlaceholderEmail}
                                    type="text"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={errors.email && touched.email ? 'input error' : 'input'}
                                />
                            {errors.email && touched.email && <div className="input-feedback">{errors.email}</div>}
                        </div>

                        <div className="field">
                            <label className="label" htmlFor="phone">
                                <FormattedMessage id="formLabelPhone" defaultMessage="Phone" />
                            </label>
                            <input
                                autoComplete="nope"
                                id="countryCode"
                                placeholder={'+47'}
                                type="text"
                                value={values.countryCode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={errors.countryCode && touched.countryCode ? 'country-code error' : 'country-code '}
                            />
                            <input
                                id="phone"
                                placeholder={translations.formPlaceholderPhone}
                                type="text"
                                value={values.phone}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={errors.phone && touched.phone ? 'input small error' : 'input small'}
                            />
                            {errors.phone && touched.phone && <div className="input-feedback">{errors.phone}</div>}
                        </div>

                        <div className="submit-wrapper">
                            <button type="submit" disabled={isSubmitting || !isValid}>
                                <FormattedMessage id="submitNext" defaultMessage="Submit" />
                            </button>
                        </div>
                    </Form>
                )}</Formik>
            </div>
        )}
};

let mapStateToProps = state => ({
    inquiryData: state.inquiryData,
    httpError: state.httpError
});

export default withRouter(injectIntl(compose(connect(mapStateToProps, {addContactInfo, addRecaptchaToken}))(ContactForm)));